export const COOKIES_ENABLED = 'cookiesEnabled'

export const SCREEN_LOADING = 'screenLoading'

export const CHANGE_OBJECT_PROPERTY = 'changeObjectProperty'

export const SET_PAY_DEBT_ON_BEHALF = 'setPayDebtOnBehalf'
export const EDIT_DEBT_INFO = 'editDebtInfo'

export const LIST_ADD = 'listAdd'
export const LIST_EDIT = 'listEdit'
export const LIST_DELETE = 'listDelete'
export const LIST_CLEAR = 'listClear'
export const CLEAR_LAST_DEBT = 'clearLastDebt'
export const CLEAR_DEBT_INFO = 'clearDebtInfo'
export const CLEAR_ALL = 'clearAll'
export const CLEAR_APP_DATA = 'clearAppData'
